import { GetIndividual } from './getIndividual';
import axios from 'axios';

/**
 * Action creators
 * @param contentType
 * @param objectUrl
 * @param individual
 * @param documentType driver_licence/passport/utility_bill
 * @returns {Promise<void>}
 * @constructor
 */
const fieldMap = {
  driver_licence: 'driverLicence',
  passport: 'passport',
  utility_bill: 'utilityBill'
};
export const UploadIndividualDocument = async (contentType, objectUrl, individualId, documentType, objIndex = null) => {
  let uploadUrl;
  if (objIndex) {
    uploadUrl = (
      await GetIndividual({
        filter: {
          _id: individualId
        },
        contentType
      })
    )[fieldMap[documentType]][objIndex].uploadUrl;
  } else {
    uploadUrl = (
      await GetIndividual({
        filter: {
          _id: individualId
        },
        contentType
      })
    )[fieldMap[documentType]].uploadUrl;
  }
  const response = await axios({
    url: objectUrl,
    method: 'GET',
    responseType: 'blob' // important
  });
  await axios.put(uploadUrl, response.data, {
    headers: {
      'Content-Type': contentType
    }
  });
  return uploadUrl;
};
